import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import InputLabel from "@material-ui/core/InputLabel";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import plLocale from "date-fns/locale/pl";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEraser } from "@fortawesome/free-solid-svg-icons";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { faFilter } from "@fortawesome/free-solid-svg-icons";

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import { _t } from "../../../i18n/lang";
import { customerTypeDictionary } from "../../../constants/customerType";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "30ch",
    },
    "& .MuiInputBase-input": {
      height: "1.8em",
    },
  },
  fabStyle: {
    marginRight: "1em",
    backgroundColor: "#cb0101",
  },
  headerColor: {
    color: "#cb0101",
  },
  headerIcon: {
    color: "rgba(0, 0, 0, 0.87)",
    marginRight: "8px",
  },
  headerWrap: {
    borderBottom: "1px solid #ccc",
    color: "rgba(0, 0, 0, 0.87)",
    paddingBottom: "16px",
    marginBottom: "20px",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

const Filter = ({ setParentFilters }) => {
  const classes = useStyles();
  const [filters, setFilters] = useState({
    phrase: "",
    type: "",
    createdAtFrom: null,
    createdAtTo: null,
  });

  useEffect(() => {
    setParentFilters(filters);
  }, [setParentFilters, filters]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFilters((prevState) => {
      return { ...prevState, [name]: value };
    });
  };

  const handleDateChange = (name, value) => {
    setFilters((prevState) => {
      return { ...prevState, [name]: value };
    });
  };

  const clearFilter = () => {
    const filtersValue = {
      phrase: "",
      type: "",
      createdAtFrom: null,
      createdAtTo: null,
    };
    setFilters(filtersValue);
  };

  return (
    <>
      <Typography variant="h4" gutterBottom className={classes.headerWrap}>
        <FontAwesomeIcon icon={faFilter} className={classes.headerIcon} />
        {_t("MMR_CUSTOMER_FILTER_HEADER")}
      </Typography>

      <form className={classes.root} noValidate autoComplete="off">
        <TextField
          label={_t("MMR_CUSTOMER_FILTER_PHRASE")}
          name="phrase"
          value={filters.phrase}
          onChange={handleChange}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton>
                  <FontAwesomeIcon size="xs" icon={faSearch} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="filter-customer-type">
            {_t("MMR_CUSTOMER_FILTER_CUSTOMER_TYPE")}
          </InputLabel>
          <Select
            value={filters.type}
            onChange={handleChange}
            inputProps={{
              name: "type",
              id: "filter-customer-type",
            }}
          >
            <MenuItem aria-label="None" value="">
              <em>{_t("MMR_CUSTOMER_TYPE_ALL")}</em>
            </MenuItem>
            <MenuItem value={customerTypeDictionary.company}>
              {_t("MMR_CUSTOMER_TYPE_COMPANY")}
            </MenuItem>
            <MenuItem value={customerTypeDictionary.endCustomer}>
              {_t("MMR_CUSTOMER_TYPE_END_CUSTOMER")}
            </MenuItem>
          </Select>
        </FormControl>

        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={plLocale}>
          <KeyboardDatePicker
            disableToolbar
            autoOk={true}
            variant="inline"
            format="dd-MM-yyyy"
            label={_t("MMR_CUSTOMER_FILTER_CREATED_AT_FROM")}
            value={filters.createdAtFrom}
            onChange={(date) => handleDateChange("createdAtFrom", date)}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
          />
        </MuiPickersUtilsProvider>

        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={plLocale}>
          <KeyboardDatePicker
            disableToolbar
            autoOk={true}
            variant="inline"
            format="dd-MM-yyyy"
            label={_t("MMR_CUSTOMER_FILTER_CREATD_AT_TO")}
            value={filters.createdAtTo}
            onChange={(date) => handleDateChange("createdAtTo", date)}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
          />
        </MuiPickersUtilsProvider>

        <div style={{ textAlign: "right", paddingTop: "1em", width: "100%" }}>
          <Button
            variant="contained"
            size="small"
            startIcon={<FontAwesomeIcon icon={faEraser} />}
            onClick={clearFilter}
            style={{
              marginRight: "0.3em",
              backgroundColor: "#cb0101",
              color: "#fff",
            }}
          >
            {_t("MMR_FILTER_BUTTON_CLEAR")}
          </Button>
        </div>
      </form>
    </>
  );
};

Filter.propTypes = {
  setParentFilters: PropTypes.func,
};

export default Filter;
